import { NavLink } from "react-router-dom";
import React from "react";

export const FamilyUnitsLinks = () => {
    return (
        <div className="links">
            <NavLink to="/familyunits/stmary" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>St. Mary</NavLink>
            <NavLink to="/familyunits/stsebastain" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>St. Sebastain</NavLink>
            <NavLink to="/familyunits/stalphonsa" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>St. Alphonsa</NavLink>
            <NavLink to="/familyunits/stantony" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>St. Antony</NavLink>
            <NavLink to="/familyunits/stlittleflower" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>St. Little Flower</NavLink>
            <NavLink to="/familyunits/stjoseph" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>St. Joseph</NavLink>
            <NavLink to="/familyunits/stthomas" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>St. Thomas</NavLink>
            <NavLink to="/familyunits/stfrancisassissi" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>St. Francis Assissi</NavLink>
        </div>
    )
}